import { useTranslations } from "next-intl";
import { memo } from "react";
import shouldHideFilterSectionInListingPage from "@utils/catalog-filters/shouldHideFilterSectionInListingPage";
import SectionButton from "./Elements/SectionButton";
import SectionContent from "./Elements/SectionContent";
import FilterCheckbox from "./Elements/FilterCheckbox";

const filterSectionKey = "brands";

const BrandsSection = memo(function BrandsSection({
  brandItems,
  refineBrand,
  listingPage,
  onClose,
  filterSectionOpened,
  setFilterSectionOpened,
}) {
  const t = useTranslations("catalog");

  if (shouldHideFilterSectionInListingPage(listingPage, "brands")) return null;
  if (brandItems.length < 2) return null;

  const sectionTitle = t(`filters.section_titles.${filterSectionKey}`);

  function displayBrandsFiltersOptions() {
    return brandItems.map((brandItem) => (
      <FilterCheckbox
        key={`filter-${brandItem.label}`}
        label={brandItem.label}
        filterType="brands"
        filterSectionKey={filterSectionKey}
        item={brandItem}
        refine={refineBrand}
      />
    ));
  }

  const checkedFilters = {
    brands: brandItems
      .filter((brandItem) => brandItem.isRefined)
      .map((brandItem) => brandItem.value),
  };

  return (
    <div>
      <SectionButton
        checkedFilters={checkedFilters}
        filterTypesToDisplay={["brands"]}
        title={sectionTitle}
        onClick={() => setFilterSectionOpened(filterSectionKey)}
      />

      <SectionContent
        isOpen={filterSectionOpened === filterSectionKey}
        onClose={onClose}
        onGoBack={() => setFilterSectionOpened("")}
        title={sectionTitle}
      >
        {displayBrandsFiltersOptions()}
      </SectionContent>
    </div>
  );
});

export default BrandsSection;
